import React, { useState, useEffect, useCallback } from "react";
import { DashboardLayout } from "../components/layout";
import PostCard from "../components/feed/PostCard";
import CreatePostModal from "../components/post/CreatePostModal";
import api from "../services/api";

// Christian-related dummy posts data
const dummyPosts = [
  // {
  //   id: "dummy-before-1",
  //   type: "reflection",
  //   author: {
  //     id: "dummy-author-1",
  //     name: "Pastor David Williams",
  //     avatar: "https://randomuser.me/api/portraits/men/52.jpg"
  //   },
  //   content: "Today's devotion from Philippians 4:13 - 'I can do all things through Christ who strengthens me.' No matter what challenge you're facing today, remember that God's strength is made perfect in our weakness. You are not alone in your struggles. Jesus is walking with you every step of the way. 🙏",
  //   tag: "Bible Reflection",
  //   createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  //   isBlessedByMe: false,
  //   engagement: { blessCount: 67, commentCount: 12 }
  // },
  // {
  //   id: "dummy-before-2",
  //   type: "prayer_request",
  //   author: {
  //     id: "dummy-author-2",
  //     name: "Sarah Mitchell",
  //     avatar: "https://randomuser.me/api/portraits/women/55.jpg"
  //   },
  //   content: "Dear brothers and sisters in Christ, please pray for my grandmother who is in the hospital with pneumonia. The doctors are concerned about her breathing. Her name is Margaret. Pray for God's healing touch and peace for our family. Thank you and God bless you all.",
  //   tag: "Prayer Request",
  //   createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
  //   isBlessedByMe: false,
  //   engagement: { blessCount: 143, commentCount: 28 }
  // },
  {
    id: "dummy-after-1",
    type: "testimony",
    author: {
      id: "dummy-author-3",
      name: "Emily Thompson",
      avatar: "https://randomuser.me/api/portraits/women/62.jpg"
    },
    beforeContent: "Before finding this community, I was struggling with anxiety and depression. I felt distant from God and stopped going to church. I couldn't pray anymore and felt like God had abandoned me. Every day was a battle just to get out of bed.",
    afterContent: "Praise the Lord! Through the support and prayers of this amazing community, I've found my way back to God. I'm now actively serving in my local church, leading a small group, and helping others who struggle with mental health. God's love has truly transformed my life! Hallelujah! ✝️",
    beforeAttachment: null,
    afterAttachment: null,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    isBlessedByMe: true,
    engagement: { blessCount: 289, commentCount: 54 }
  }
];

const CommunityPage = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [visibleDummyPosts, setVisibleDummyPosts] = useState(dummyPosts.map(p => p.id));

  const fetchPosts = useCallback(async (p = 1, append = false) => {
    try {
      setLoading(true);
      const d = await api.getPosts(p, 10);
      if (append) setPosts((prev) => [...prev, ...d.posts]);
      else setPosts(d.posts);
      setHasMore(p < d.totalPages);
    } catch (err) {
      console.error("Failed to load community feed:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPosts(1);
  }, [fetchPosts]);

  const loadMore = () => {
    const n = page + 1;
    setPage(n);
    fetchPosts(n, true);
  };

  const handlePostCreated = (p) => setPosts((prev) => [p, ...prev]);
  
  const handlePostDelete = (id) => {
    // Check if it's a dummy post
    // if (id.startsWith("dummy")) {
    //   setVisibleDummyPosts(prev => prev.filter(pid => pid !== id));
    // } else {
      setPosts((prev) => prev.filter((p) => p.id !== id));
    // }
  };

  // Active dummy posts (not deleted)
  const activeDummyPosts = dummyPosts.filter(p => visibleDummyPosts.includes(p.id));

  return (
    <DashboardLayout onCreatePost={() => setShowCreate(true)}>
      <div
        className="flex-1 min-w-0 py-4 sm:py-6 px-4 sm:px-8 lg:px-[20px] 2xl:px-[20px] overflow-y-auto"
        style={{
          maxHeight: "calc(100vh - 56px)",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <h1 className="text-[20px] sm:text-[28px] font-bold text-[#0F1D2E] mb-4 sm:mb-5 tracking-tight font-body ">
          Community
        </h1>
        
        {/* Show loading state */}
        {loading && posts.length === 0 && activeDummyPosts.length === 0 ? (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-3 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (posts.length === 0 && activeDummyPosts.length === 0) ? (
          <div className="text-center py-16">
            <p className="text-gray-400 text-[15px] mb-4">
              No community posts yet.
            </p>
            <button
              onClick={() => setShowCreate(true)}
              className="px-6 py-2.5 bg-primary text-white rounded-full text-[14px] font-semibold"
            >
              Create Post
            </button>
          </div>
        ) : (
          <>
            {/* Render dummy posts first */}
            {/* {activeDummyPosts.map((dummyPost) => (
              <PostCard 
                key={dummyPost.id} 
                post={dummyPost} 
                onDelete={() => handlePostDelete(dummyPost.id)}
              />
            ))}
             */}
            {/* Render real posts from API */}
            {posts.map((post) => (
              <PostCard key={post.id} post={post} onDelete={handlePostDelete} />
            ))}
            
            {/* Load more button */}
            {hasMore && (
              <div className="text-center py-4">
                <button
                  onClick={loadMore}
                  disabled={loading}
                  className="text-primary text-[14px] font-semibold hover:underline disabled:opacity-50"
                >
                  {loading ? "Loading..." : "Load more"}
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <CreatePostModal
        isOpen={showCreate}
        onClose={() => setShowCreate(false)}
        onPostCreated={handlePostCreated}
      />
    </DashboardLayout>
  );
};

export default CommunityPage;